require('expose-loader?SeoComponent!../src/app/seo');
